import Spinner from '@/common/Spinner';
import styles from './Loading.module.scss';

function Loading() {
  return (
    <div className={styles.container}>
      <Spinner />
      <span className={styles.text}>Loading Player Data</span>
    </div>
  );
}

export default Loading;
